import { useCustomSWR } from 'utils/hooks/fetchers'

export const useVenderById = (id) => {
  return useCustomSWR(id && `/venders/${id}`)
}
